import { View, Pressable, StyleSheet, Animated } from 'react-native';
import React, { useRef, useState } from 'react';
import { BMPrimitives, useBMTheme } from '../../../theme';
import BMText from '../../Text/BMText';
import BMCheckbox from '../../Checkbox/BMCheckbox';
const DropdownItem = (props) => {
    const { label, LeadingIcon, TrailingIcon, active, trailingText, description, onItemSelect, value, isFirst, isLast, multiSelect, } = props;
    const [isFocused, setIsFocused] = useState(false);
    // styles
    const { BMComponents } = useBMTheme();
    const [styles] = useState(() => dropdownItemStyles(BMComponents));
    const [componentSize, setComponentSize] = useState({ height: 0, width: 0 });
    const onLayout = (event) => {
        const { width, height } = event.nativeEvent.layout;
        setComponentSize({ height: height, width });
    };
    // animations
    const backgroundColorAnimation = useRef(new Animated.Value(0)).current;
    const backgroundColorInterpolation = backgroundColorAnimation.interpolate({
        inputRange: [0, 1],
        outputRange: [
            active ? BMComponents.BMStyleSurfaceBgcolorHighlight : BMComponents.BMStyleSurfaceBgcolor,
            BMComponents.BMStyleSurfaceBgcolorInventory,
        ],
    });
    // handlers
    const handleHoverIn = () => {
        Animated.timing(backgroundColorAnimation, {
            toValue: 1,
            duration: BMPrimitives.BMAnimation.duration.quick,
            useNativeDriver: false,
        }).start();
    };
    const handleHoverOut = () => {
        Animated.timing(backgroundColorAnimation, {
            toValue: 0,
            duration: BMPrimitives.BMAnimation.duration.quick,
            useNativeDriver: false,
        }).start();
    };
    const handleFocus = () => {
        setIsFocused(true);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    return (<Pressable onHoverIn={handleHoverIn} onHoverOut={handleHoverOut} onFocus={handleFocus} onBlur={handleBlur} onLayout={onLayout} onPress={() => onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect({ value: value !== null && value !== void 0 ? value : label, label })} style={styles.pressable}>
      <Animated.View style={[styles.container, { backgroundColor: backgroundColorInterpolation }]}>
        {multiSelect ? <BMCheckbox value={active}/> : null}
        {LeadingIcon ? (<View style={styles.leadingIconContainer}>
            <LeadingIcon width={24} height={24} accentColor={BMComponents.BMStyleIconInkPrimary}/>
          </View>) : null}
        <View style={styles.labelContainer}>
          <BMText variant={active ? 'uiLargeEm' : 'uiLarge'} ink={'BMStyleTextInkPrimary'}>
            {label}
          </BMText>
          {description && <BMText variant="paragraphSmall">{description}</BMText>}
        </View>
        {TrailingIcon || trailingText ? (<View style={styles.trailingComponentContainer}>
            {TrailingIcon && <TrailingIcon width={24} height={24} accentColor={BMComponents.BMStyleIconInkPrimary}/>}
            {trailingText && <BMText variant="paragraphSmall">{trailingText}</BMText>}
          </View>) : null}
      </Animated.View>

      {/* focus ring */}
      <Animated.View style={{
            borderColor: BMComponents.BMStyleLineBordercolorFocus,
            borderWidth: BMPrimitives.BMBorder.width.thick,
            position: 'absolute',
            zIndex: 1,
            width: componentSize.width,
            height: componentSize.height,
            left: 0,
            top: 0,
            opacity: isFocused ? 1 : 0,
            borderTopLeftRadius: isFirst ? BMComponents.BMStyleCardRadiusCompact : 0,
            borderTopRightRadius: isFirst ? BMComponents.BMStyleCardRadiusCompact : 0,
            borderBottomLeftRadius: isLast ? BMComponents.BMStyleCardRadiusCompact : 0,
            borderBottomRightRadius: isLast ? BMComponents.BMStyleCardRadiusCompact : 0,
        }}/>
    </Pressable>);
};
export default DropdownItem;
const dropdownItemStyles = (BMComponents) => StyleSheet.create({
    pressable: {
        // @ts-ignore
        outlineStyle: 'none',
    },
    container: {
        flexDirection: 'row',
        paddingHorizontal: BMPrimitives.BMSize.xl,
        paddingVertical: BMPrimitives.BMSize.md,
        alignItems: 'flex-start',
    },
    leadingIconContainer: {
        marginRight: BMPrimitives.BMSize.sm,
    },
    labelContainer: {
        flex: 1,
    },
    trailingComponentContainer: {
        alignItems: 'flex-end',
        marginLeft: BMPrimitives.BMSize.sm,
    },
});
